import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AppSettings, Eletricista } from '@/types';
import * as api from './api';

export function useSettings() {
  return useQuery<AppSettings>({
    queryKey: ['app', 'definicoes'],
    queryFn: api.fetchSettings,
    staleTime: 5 * 60_000,
  });
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: api.updateSettings,
    onSuccess: (settings) => {
      queryClient.setQueryData(['app', 'definicoes'], settings);
      void queryClient.invalidateQueries({ queryKey: ['partes'] });
      void queryClient.invalidateQueries({ queryKey: ['mapas'] });
    },
  });
}

export function useEquipa(enabled = true) {
  return useQuery<Eletricista[]>({
    queryKey: ['app', 'equipa'],
    queryFn: api.fetchEquipa,
    enabled,
    staleTime: 5 * 60_000,
  });
}
